module.exports = __webpack_public_path__ + "static/media/ic_download-primary.e53782d0.svg";